import { apiGet } from '../../api'

export const get_modules = () => {
  return apiGet({
    endpoint: 'modules/all_modules'
  })
}
